import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 07C8266A-A135-443C-B2DD-4148CD718C51
 * name parking
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/parking.svg
 * tags
 * - Places 
 */
export const ParkingIcon = createSvgIcon(<><path d="M13.2,11H10V7H13.2A2,2 0 0,1 15.2,9A2,2 0 0,1 13.2,11M13,3H6V21H10V15H13A6,6 0 0,0 19,9C19,5.68 16.31,3 13,3Z" /></>, 'ParkingIcon');
export default ParkingIcon